module.exports = new __parcel__URL__("classic-board-app-skeleton.tpl.bf1c26f5.svg").toString();